import * as React from 'react'
import { Grid as G, Row as R, Col as C } from 'react-flexbox-grid'

import addSubcomponents from '../utils/addSubcomponents'
import { DivAttributes } from '../utils/types'

interface Props {
  children?: React.ReactNode
}

interface GridProps extends Props {
  fluid?: boolean
  style?: React.CSSProperties
}

interface RowProps extends Props {}

interface ColProps extends Props {
  xs?: number
  sm?: number
  md?: number
  lg?: number
  span?: number
}

const Grid = React.forwardRef<G, DivAttributes & GridProps>(
  ({ children, fluid = true, style = {}, ...props }, ref) => (
    <G
      ref={ref}
      fluid={fluid}
      style={{ ...style, margin: fluid ? '0 -16px' : 0 }}
      {...props}
    >
      {children}
    </G>
  )
)

export const Row = React.forwardRef<R, DivAttributes & RowProps>(
  ({ children, ...props }, ref) => (
    <R ref={ref} {...props}>
      {children}
    </R>
  )
)

export const Col = React.forwardRef<C, DivAttributes & ColProps>(
  ({ children, xs, sm, md, lg, span, ...props }, ref) => {
    const spanActual = span || xs || sm || md || lg

    return (
      <C
        ref={ref}
        xs={xs || spanActual}
        sm={sm || spanActual}
        md={md || spanActual}
        lg={lg || spanActual}
        {...props}
      >
        {children}
      </C>
    )
  }
)

export default addSubcomponents(
  {
    Col,
    Row,
  },
  Grid
)
